import axios from './axios'

export const getDirectory = ({ params } = {}) => axios.get('/model_files/get_directory', { params })
export const getFileUri = ({ params } = {}) => axios.get('/model_files/get_file_uri', { params })
export const createDirectory = ({ data } = {}) => axios.post(`/model_files/create_directory`, data)
export const renameDirectory = ({ data } = {}) => axios.put(`/model_files/rename_directory`, data)
export const renameFile = ({ data } = {}) => axios.put(`/model_files/rename_file`, data)
export const deleteItems = ({ data } = {}) => axios.put(`/model_files/delete_items`, data)
export const uploadFile = ({ data, config } = {}) => axios.post(`/model_files/upload`, data, config)
